import type { Tour } from '../tour-types';

/**
 * The Debrief tab (`?screen=report`), which only an ended or deployed experiment has. It
 * lands on the read view: the after action report card, with the answers in a drawer under
 * it. The drawer starts open when nothing has been answered yet and closed once there is a
 * report to read, so the questions step only plays in the first case. The end-of-test
 * wizard is a dialog of its own and has no steps here.
 */
export const experimentDebriefTour: Tour = {
  key: 'experiments.debrief',
  version: 1,
  routes: ['/experiments/:id'],
  screen: 'report',
  steps: [
    {
      anchor: 'debrief-result',
      placement: 'right',
      title: 'The result',
      body: 'What the platform measured: the verdict, the headline numbers, and whether your hypothesis from the Brief held. None of it needs filling in.',
    },
    {
      anchor: 'debrief-lesson',
      placement: 'left',
      title: 'What the team learned',
      body: 'The lesson, why it happened, any caveats and the next step, taken from your answers below. This is what someone reads when they look back at the test.',
    },
    {
      anchor: 'debrief-answers',
      placement: 'top',
      requires: 'experiments:create',
      title: 'Your answers',
      body: 'Opens the questions behind the card, and shows how many are answered. You can change them at any time; the card follows as you type.',
    },
    {
      anchor: 'debrief-questions',
      placement: 'top',
      requires: 'experiments:create',
      title: 'The questions',
      body: 'Whether the result matched what you expected, what you will do next, what else may have affected it, and what you learned. Save debrief keeps them with the experiment for your team.',
    },
  ],
};
